import React from "react";
import { cn } from "../../lib/utils";

const Container = ({ children, className, maxWidth = "max-w-screen-xl", ...props }) => {
  return (
    <div className={cn("w-full mx-auto px-4 md:px-6 lg:px-8", maxWidth, className)} {...props}>
      {children}
    </div>
  );
};

export { Container };
